import { LoaderNewWrapper } from './styles';

type LoaderNewType = {
  size?: 'small' | 'medium';
};

export const LoaderNew = ({ size = 'medium' }: LoaderNewType) => {
  return <LoaderNewWrapper size={size} />;
};
